import React, { useEffect, useRef } from 'react';

type AutoGrowTextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export function AutoGrowTextarea(props: AutoGrowTextareaProps) {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const resize = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  // Resize on mount and when value changes
  useEffect(() => resize(), [props.value]);

  return (
    <textarea
      {...props}
      ref={textareaRef}
      onInput={(event) => {
        resize();
        props.onInput?.(event);
      }}
      rows={1}
      style={{ overflow: 'hidden', resize: 'none', ...props.style }}
    />
  );
}
